export default {
  formTitle: 'Change Password',
  passwordPlaceholder: 'Enter new Password',
  confirmPasswordPlaceholder: 'Confirm your Password',
  confirmPasswordLabel: 'Confirm your Password',
  submitButton: 'Change Password',
};
